import React, { useEffect, useState } from "react";
import styles from "./WordModel.module.css";
import axios from "axios";
import AudioPlayer from "../components/quiz/AudioPlayer";
import { use } from "react";

const FullWordModel2 = (props) => {
  const username = localStorage.getItem("username");
  const appToken = localStorage.getItem("webtoken");
  const auth = "Bearer " + appToken;
  const [audiolink, setAudioLink] = useState("");
  const [wik, setWik] = useState("");
  const [mwun, setMwun] = useState("");
  const [mwfree, setMwfree] = useState("");
  const [currentquestion, setCurrentQuestion] = useState({});
  const [catname, setCatname] = useState("");
  const [subcatname, setSubcatname] = useState("");
  const [packagename, setPackagename] = useState("");


  useEffect(() => {
    if (props.selectedid === 0) return;
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://s3napi-dev.s3nsoftware.com/api/QuizDatas/GetWordFullInfo?WordId=${props.selectedid}&Username=${username}`,
      headers: {
        Authorization: auth.toString(),
      },
    };

    axios
      .request(config)
      .then((response) => {
        setCurrentQuestion(response.data.QD);
        setCatname(response.data.Cat);
        setSubcatname(response.data.Subcat);
        setPackagename(response.data.Pack);
        let ad;

        if (response.data.audio == null) {
          const firstChar = response.data.QD.Word.trim()
            ? response.data.QD.Word.trim().charAt(0).toLowerCase()
            : "";
          ad =
            "sound://gtts_audio_files/" +
            firstChar +
            "/" +
            response.data.QD.Word +
            ".mp3";
        } else {
          ad = response.data.QD.audio;
        }

        const mp3 = ad.replace(/sound:\/\//g, "");
        const url = `https://s3nsoftware.com/${mp3}`;
        setAudioLink(url);

        setWik(`https://en.wiktionary.org/wiki/${response.data.QD.Word}`);
        setMwun(
          `https://unabridged.merriam-webster.com/unabridged/${response.data.QD.Word}`
        );
        setMwfree(
          `https://www.merriam-webster.com/dictionary/${response.data.QD.Word}`
        );
      })
      .catch((error) => {
        ////console.log(error);
      });
  }, [props.selectedid]);

  const closeModal = () => {
    props.updateIsOpen(false);
  };

  return (
    <div className={styles.modal_container}>
      {props.open && (
        <div className={styles.modal}>
          <div className={styles.modal_content}>
            <span className={styles.close} onClick={closeModal}>
              &times;
            </span>
            <div>
              <label
                style={{
                  textDecoration: "underline",
                  fontWeight: "bold",
                  fontSize: 25,
                }}
              >
                {currentquestion.Word}
              </label>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid black",
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        width: "30%",
                        fontWeight: "bold",
                        border: "1px solid black",
                        padding: "8px",
                      }}
                    >
                      {"Part of speech: "}
                    </td>
                    <td
                      style={{
                        width: "70%",
                        textAlign: "start",
                        border: "1px solid black",
                        padding: "8px",
                      }}
                    >
                      {currentquestion.pos}
                    </td>
                  </tr>
                  {currentquestion.Id > 0 ? (
                    <tr>
                      <td
                        style={{
                          width: "30%",
                          fontWeight: "bold",
                          border: "1px solid black",
                          padding: "8px",
                        }}
                      >
                        {"Definition: "}
                      </td>
                      <td
                        style={{
                          width: "70%",
                          textAlign: "start",
                          border: "1px solid black",
                          padding: "8px",
                        }}
                      >
                        {currentquestion.defn}
                      </td>
                    </tr>
                  ) : (<></>)}

                  {currentquestion.Id > 0 ? (
                    <tr>
                      <td
                        style={{
                          width: "30%",
                          fontWeight: "bold",
                          border: "1px solid black",
                          padding: "8px",
                        }}
                      >
                        {"Etymology: "}
                      </td>
                      <td
                        style={{
                          width: "70%",
                          textAlign: "start",
                          border: "1px solid black",
                          padding: "8px",
                        }}
                      >
                        {currentquestion.etym}
                      </td>
                    </tr>
                  ) : (<></>)}
                  {currentquestion.Id > 0 ? (
                    <tr>
                      <td
                        style={{
                          width: "30%",
                          fontWeight: "bold",
                          border: "1px solid black",
                          padding: "8px",
                        }}
                      >
                        {"Sentence: "}
                      </td>
                      <td
                        style={{
                          width: "70%",
                          textAlign: "start",
                          border: "1px solid black",
                          padding: "8px",
                        }}
                      >
                        {currentquestion.sent}
                      </td>
                    </tr>
                  ) : (<></>)}{currentquestion.Id > 0 ? (
                    <tr>
                      <td
                        style={{
                          width: "30%",
                          fontWeight: "bold",
                          border: "1px solid black",
                          padding: "8px",
                        }}
                      >
                        {"Pronunciation: "}
                      </td>
                      <td
                        style={{
                          width: "70%",
                          textAlign: "start",
                          border: "1px solid black",
                          padding: "8px",
                        }}
                      >
                        {currentquestion.Pron}{" "}
                        <AudioPlayer
                          audioUrl={audiolink}
                          currentIndex={1}
                          size={30}
                          color={"#000"}
                          init={false}
                          quiz={false}
                        />
                      </td>
                    </tr>
                  ) : (<></>)}{currentquestion.Id > 0 ? (
                    <tr style={{ marginTop: 25 }}>
                      <td
                        style={{
                          width: "50%",
                          fontWeight: "bold",
                          border: "1px solid black",
                          padding: "8px",
                          wordWrap: "break-word", // Ensure content wraps nicely in smaller screens
                        }}
                      >
                        {"References: "}
                      </td>
                      <td
                        style={{
                          width: "100%",
                          textAlign: "start",
                          border: "1px solid black",
                          padding: "8px",
                          display: "flex",
                          flexWrap: "wrap", // Wrap the content in smaller screens
                          justifyContent: "flex-start",
                        }}
                      >
                        <span
                          style={{
                            padding: 5,
                            backgroundColor: "#ff6a00",
                            borderRadius: 15,
                            marginRight: 5,
                            marginBottom: 5, // Ensure space between items when wrapping
                            display: "inline-block",
                          }}
                        >
                          <a href={wik} target="_blank" rel="noopener noreferrer">
                            Wiktionary
                          </a>
                        </span>
                        <span
                          style={{
                            padding: 5,
                            backgroundColor: "#ff0000",
                            borderRadius: 15,
                            marginRight: 5,
                            marginBottom: 5,
                            display: "inline-block",
                          }}
                        >
                          <a
                            href={mwun}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            MW Unabridged
                          </a>
                        </span>
                        <span
                          style={{
                            padding: 5,
                            backgroundColor: "#008000",
                            borderRadius: 15,
                            marginRight: 5,
                            marginBottom: 5,
                            display: "inline-block",
                          }}
                        >
                          <a
                            href={mwfree}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            MW Free
                          </a>
                        </span>
                      </td>
                    </tr>
                  ) : (<></>)}
                </tbody>
              </table>
            </div>

            {username === "null" || username === null ? (
              <div style={{ marginTop: 20 }}>
                If you want more information or features, please signin and subscribe the packages.
              </div>
            ) : currentquestion.Id > 0 ? <></> : <div style={{ marginTop: 20 }}>
              <span style={{ fontWeight: "bold" }}>
                Note:{" "}
                <span style={{ fontWeight: "normal" }}>
                  This is a demo version, and some features may be limited. For more information or to access additional features, please subscribe to the packages mentioned below in the collection or category. </span>
              </span>
            </div>
            }
            <div style={{ fontWeight: "normal" }}>
              <div>
                <span style={{fontWeight:'bold'}}>Collection: </span>
                <span style={{ fontWeight: 'normal' }}>{packagename}</span>
                <div style={{ margin: '5px 0' }}>
                  → <span style={{fontWeight:'bold'}}>Category: </span>
                  <span style={{ fontWeight: 'normal' }}>{catname}</span>
                  <div style={{ margin: '5px 0' }}>
                    → <span style={{fontWeight:'bold'}}>Subcategory: </span>
                    <span style={{ fontWeight: 'normal' }}>{subcatname}</span>
                  </div>
                </div>
              </div>
              {currentquestion.Id > 0 ? null : (
                // <span
                //   onClick={() => { window.location.href = "/#alldata"; closeModal() }}
                //   style={{
                //     cursor: 'pointer',
                //     color: 'green',
                //     backgroundColor: 'yellow',
                //     padding: '5px',
                //     borderRadius: '5px',
                //     marginTop: '10px'
                //   }}
                // >
                //   Subscribe
                // </span>
                " "
              )}
            </div>



          </div>

          {/* <div className={styles.modal_footer}>
            <button className={styles.close_button} onClick={closeModal}>
              Close
            </button> 
            </div> */}
        </div>
      )}
    </div>
  );
};

export default FullWordModel2;
